(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.MainController = (function(superClass) {
    extend(MainController, superClass);

    function MainController(scope, transitions, modal) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      MainController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.openProfileDialog = (function(_this) {
        return function() {
          return _this.modal.open({
            windowClass: 'medium_dialog',
            templateUrl: 'backend/grower/profile/layout',
            controller: 'Profile.Controllers.ProfileController',
            resolve: {
              ProfileData: [
                'Profile.Services.ProfileService', function(repo) {
                  return repo.getProfileData();
                }
              ]
            }
          });
        };
      })(this);
    }

    return MainController;

  })(Controller);

}).call(this);
